import { cn } from '@/lib/utils/utils'

/**
 * myworldesk form control surface — **only** composed in `components/form/*` wrappers.
 * Keeps `components/ui` inputs/select/textarea on default shadcn styling.
 *
 * - Very subtle light border, moderate radius (`rounded-2xl`), generous padding, pronounced layered shadow.
 */
const FORM_FIELD_SHADOW =
    'shadow-[0_16px_44px_-16px_rgba(20,63,63,0.26),0_10px_28px_-8px_rgba(15,15,15,0.12),0_2px_8px_-2px_rgba(15,15,15,0.05)]'
const FORM_FIELD_SHADOW_HOVER =
    'hover:shadow-[0_20px_52px_-14px_rgba(20,63,63,0.30),0_14px_36px_-8px_rgba(15,15,15,0.14),0_4px_12px_-2px_rgba(15,15,15,0.06)]'

const FORM_FIELD_BASE = cn(
    'border border-slate-200/55 bg-card text-foreground transition-[box-shadow,border-color]',
    FORM_FIELD_SHADOW,
    FORM_FIELD_SHADOW_HOVER,
    'rounded-2xl placeholder:text-muted-foreground/80',
    'hover:border-slate-200/80',
    'focus-visible:border-petrol/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-petrol/25 focus-visible:ring-offset-0',
    'disabled:cursor-not-allowed disabled:opacity-50'
)

export const formFieldInputClassName = cn(FORM_FIELD_BASE, 'min-h-12 w-full px-5 py-3.5 text-base md:text-sm')

export const formFieldTextareaClassName = cn(
    FORM_FIELD_BASE,
    'min-h-32 w-full resize-y px-5 py-4 text-base leading-relaxed md:text-sm'
)

/** Radix SelectTrigger — flex + chevron layout */
export const formFieldSelectTriggerClassName = cn(
    FORM_FIELD_BASE,
    'flex h-auto min-h-12 w-full cursor-pointer items-center justify-between px-5 py-3.5 text-left text-base md:text-sm'
)

/** Popover combobox button (SelectFormField type `popover`) */
export const formFieldComboboxTriggerClassName = cn(
    FORM_FIELD_BASE,
    'flex min-h-12 w-full cursor-pointer items-center justify-between px-5 py-3.5 text-base font-normal md:text-sm'
)

/** Host/settings “required” emphasis on a single control — not whole section cards. */
export const formFieldRequiredHighlightClassName =
    'border-2 border-solid !border-[#7f1d1d] bg-card hover:bg-card hover:!border-[#7f1d1d] focus-visible:bg-card focus-visible:!border-[#7f1d1d] focus-visible:ring-[#7f1d1d]/20'
